import Api from 'api'

const config = { baseURL: '/api/app/agency' }

const api = new Api(config)

api.fetchInfo = () => api.get('/')

api.create = ({ ...rest }) => api.post('', { ...rest })

api.transfer = ({ clientId, ...rest }) =>
  api.post(`/clients/${clientId}/transfer`, { ...rest })

export default api
